import { ReactNode } from "react";
import { FaPeopleGroup, FaHandshake } from "react-icons/fa6";
import { BiDollar } from "react-icons/bi";
import { MdOutlineContactMail } from "react-icons/md";
import { HiChatBubbleLeftRight } from "react-icons/hi2";
import { IoDocumentText } from "react-icons/io5";
import { FaCoins } from "react-icons/fa";
import { MdGroupAdd } from "react-icons/md";
import { Container, Step } from "./Stepper.styles";

type IconName =
  | "group-register"
  | "booking-register"
  | "select-club"
  | "confirm-club"
  | "money"
  | "invite-member"
  | "coin"
  | "addMember";

// 단체등록      <FaPeopleGroup /> <GrGroup />
// 부킹신청     <IoDocumentTextOutline /> <IoDocumentText /> <PiHandDepositBold /> <PiHandDepositLight />
// 조건협의    <GiTabletopPlayers /> <GiTalk /> <HiChatBubbleLeftRight />
// 부킹확정    <FaRegHandshake /> <FaHandshake />
// 보증금확인  <BiDollar />
// 멤버등록    <MdOutlineContactMail />

const IconCompObj: { [key in IconName]: ReactNode } = {
  "group-register": <FaPeopleGroup />,
  "booking-register": <IoDocumentText />,
  "select-club": <HiChatBubbleLeftRight />,
  "confirm-club": <FaHandshake />,
  money: <BiDollar />,
  "invite-member": <MdOutlineContactMail />,
  coin: <FaCoins />,
  addMember: <MdGroupAdd />,
};

function Stepper(props: {
  className?: string;
  stepsXpadding?: string;
  steps: {
    label?: ReactNode;
    nextLineType?: "dotted" | "solid";
    title?: string;
    isError?: boolean;
    icon?: IconName;
    img?: string; // 이미지 경로 추가
  }[];
  currentIdx?: number | null;
  currentStatus?: "done" | "error";
  title?: string;
  logo?: string;
}) {
  return (
    <Container className={props.className} $stepsXpadding={props.stepsXpadding}>
      {props.title ? (
        <h4>

          {props.title}
        </h4>
      ) : null}
      <div className="steps">
        {props.steps.map((st, idx) => {
          return (
            <Step
              key={`step-${idx}`}
              className={(() => {
                const classes = [];
                if (props.currentIdx === null) {
                  classes.push("inactive");
                }
                if (props.steps.length - 1 !== idx) {
                  classes.push("flex-1");
                }
                if (props.currentIdx === idx && !st.isError) {
                  classes.push("dotted");
                }
                if ((props.currentIdx ?? 9999) < idx) {
                  classes.push("inactive");
                }
                if (st.isError) {
                  classes.push("error");
                }
                return classes.join(" ");
              })()}
            >
              <div className="btn">
                <div className="icon-box">
                  {st.img ? (
                    <img
                      src={st.img}
                      alt={`step-${idx}`}
                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                    />
                  ) : st.icon ? (
                    IconCompObj[st.icon]
                  ) : (
                    ""
                  )}
                </div>
                <div className={`label-section3`} key={`label-${idx}`}>
                  {st.label}
                </div>
              </div>
              {props.steps.length - 1 === idx ? null : (
                <>
                  <div className="line" />
                </>
              )}
            </Step>
          );
        })}
      </div>
    </Container>
  );
}

export default Stepper;
